import { cva, VariantProps } from "cva";

const containerClasses = cva("w-full", {
  variants: {
    border: {
      true: "border-1 border-t-0 border-gray-200",
      false: "border-0",
    },
    gutters: {
      true: "p-s md:p-m first:pt-l",
      false: "",
    },
  },
  defaultVariants: {
    border: true,
    gutters: true,
  },
});

export type SidecarContainerProps = VariantProps<typeof containerClasses> & {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

export const SidecarContainer: React.FC<SidecarContainerProps> = ({
  children,
  className,
  border,
  gutters,
  style,
}) => (
  <div
    className={containerClasses({ border, gutters, className })}
    style={style}
  >
    {children}
  </div>
);
